var link_viewer_default = {
  "fontElementMap": "A0siY",
  "link": "_7PR4H",
  "linkInEditor": "ZB80G",
  "linkInViewer": "_7emGI",
  "toolbarUrlContainer": "m47LT",
  "toolbarUrl": "yx8xO",
  "toolbarUrlAnchor": "F26FR"
};
export {
  link_viewer_default as default
};
//# sourceMappingURL=link-viewer-scss.js.map
